import DIApi from './_diApi';

class ReceiptAPI extends DIApi {
  controllerName = 'Receipts';
}

export default new ReceiptAPI();
